var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
// react
import React, { useEffect, useState } from 'react';
import { withStyles, Stepper, Step, StepLabel } from '@material-ui/core';
import { certificateTypeOpTrs, dateTransSerial } from 'consts';
import styled from 'styled-components';
import { useSnackbar } from 'notistack';
import { MasterGrids2, PlainText } from 'component/LHH/MasterGrids/MasterGrids';
import Alert from '@material-ui/lab/Alert';
import { ButtonContain } from 'component/material/ButtonContained/Button';
import { ButtonBar } from 'component/material/ButtonContained/ButtonBar';
import Authentication from 'view/RealName/Authentication';
import { PageTypeEnum } from 'reducers/sharedata/types';
import { getToken } from 'main_api';
import { successSnack } from 'component/config';
import SystemCheck from '../RealName/SystemCheck';
import UserForm from './UserForm';
// styled ---------------------------------------------
var StyleRoot = styled.div(templateObject_1 || (templateObject_1 = __makeTemplateObject(["\n  /* position: absolute;\n  top: 10%;\n  left: 50%;\n  transform: translateX(-50%); */\n  font-size: 1.2em;\n  min-width: 350px;\n  width: 60%;\n  padding: 0 20px;\n  .MuiStepper-root {\n    background-color: rgb(247, 247, 247);\n  }\n"], ["\n  /* position: absolute;\n  top: 10%;\n  left: 50%;\n  transform: translateX(-50%); */\n  font-size: 1.2em;\n  min-width: 350px;\n  width: 60%;\n  padding: 0 20px;\n  .MuiStepper-root {\n    background-color: rgb(247, 247, 247);\n  }\n"])));
var StyleAlert = withStyles({
    root: {
        fontSize: '1.8rem',
        marginBottom: '5px',
        display: 'flex',
        justifyContent: 'center',
    },
    icon: {
        fontSize: '1.5em',
    },
})(Alert);
var StyleDiv = styled.div(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  .MuiGrid-item {\n    font-size: 1.3rem;\n  }\n"], ["\n  .MuiGrid-item {\n    font-size: 1.3rem;\n  }\n"])));
// component ---------------------------------------------
var Register = function (props) {
    var enqueueSnackbar = useSnackbar().enqueueSnackbar;
    var history = props.history;
    var _a = useState(PageTypeEnum.home), pageShow = _a[0], setPageShow = _a[1];
    var _b = useState(0), activeStep = _b[0], setActiveStep = _b[1];
    var _c = useState({
        idNo: '',
        idPassword: '',
        certificateType: 'C',
    }), authData = _c[0], setAuthData = _c[1];
    var _d = useState({
        lang: 'TW',
        personCheck: 'N',
        userType: 'EZWAY',
        isCitizen: '',
        certificateType: '',
        userId: '',
        userName: '',
        userNameE: '',
        userPwd: '',
        email: '',
        address: '',
        verCode: '',
        telNo: '',
        nhiCard: '',
    }), userData = _d[0], setUserData = _d[1];
    var handleNext = function () {
        return setActiveStep(function (prevActiveStep) { return prevActiveStep + 1; });
    };
    var certSuccess = function (certInfo) {
        setUserData(function (prev) { return (__assign(__assign({}, prev), { userName: authData.certificateType === 'C' || authData.isChina === 'Y'
                ? certInfo.subjectCN
                : undefined, userNameE: authData.certificateType !== 'C' && authData.isChina === 'N'
                ? certInfo.subjectCN
                : undefined, isCitizen: authData.certificateType === 'C' ? 'Y' : 'N', isChina: authData.isChina, certificateType: authData.certificateType, cdcData: JSON.stringify(certInfo) })); });
        handleNext();
        enqueueSnackbar('驗證成功', successSnack);
    };
    var handleSuccess = function () {
        setUserData(function (prev) { return (__assign(__assign({}, prev), { idNo: authData.idNo, verifyFlag: 'Y', verifyType: 'N', verifiedStatus: 'W' })); });
    };
    useEffect(function () {
        getToken(enqueueSnackbar);
    }, []);
    var QueryConds = [
        {
            t: '持有證件',
            colspan: authData.certificateType === 'C' ? 2 : 1,
            child: (React.createElement(PlainText, null, certificateTypeOpTrs.trans[userData.certificateType] ||
                userData.certificateType)),
        },
        {
            t: (React.createElement(React.Fragment, null,
                "\u662F\u5426\u70BA\u5927\u9678\u5730\u5340",
                React.createElement("br", null),
                "\u53CA\u9999\u6E2F\u6FB3\u9580\u4EBA\u6C11")),
            show: authData.certificateType !== 'C',
            child: React.createElement(PlainText, null, userData.isChina === 'Y' ? '是' : '不是'),
        },
        {
            t: '中文姓名',
            child: React.createElement(PlainText, null, userData.userName),
        },
        {
            t: '英文姓名',
            child: React.createElement(PlainText, null, userData.userNameE),
        },
        { t: '帳號', child: React.createElement(PlainText, null, userData.userId) },
        {
            t: userData.certificateType === 'C' ? '身分證號碼' : '居留證號碼',
            child: React.createElement(PlainText, null, userData.idNo),
        },
        {
            t: '出生年月日',
            colspan: userData.certificateType === 'C' ? 2 : 1,
            child: React.createElement(PlainText, null, dateTransSerial(userData.birthDate)),
        },
        {
            t: '居留證有效日期',
            show: userData.certificateType !== 'C',
            child: React.createElement(PlainText, null, dateTransSerial(userData.expiryDate)),
        },
        // {
        //   t: '健保卡卡號',
        //   show: userData.certificateType === 'C',
        //   colspan: 2,
        //   child: <PlainText>{userData.nhiCard}</PlainText>,
        // },
        { t: 'Email', child: React.createElement(PlainText, null, userData.email) },
        { t: '手機號碼', child: React.createElement(PlainText, null, userData.telNo) },
        { t: '地址', colspan: 2, child: React.createElement(PlainText, null, userData.address) },
    ];
    return (React.createElement("div", { style: {
            backgroundColor: 'rgb(247, 247, 247)',
            height: '100vh',
            minHeight: 500,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
        } },
        React.createElement(StyleRoot, null,
            React.createElement("div", { style: { display: pageShow === PageTypeEnum.home ? 'block' : 'none' } },
                React.createElement(Stepper, { activeStep: activeStep, alternativeLabel: true }, ['系統環境檢查', '身分驗證', '資料填寫'].map(function (label) { return (React.createElement(Step, { key: label },
                    React.createElement(StepLabel, null, label))); })),
                activeStep === 0 && (React.createElement(SystemCheck, { handleBack: function () { return props.history.goBack(); }, handleNext: handleNext })),
                activeStep === 1 && (React.createElement(Authentication, { actinoType: "Register", _authData: [authData, setAuthData], certSuccess: certSuccess, signSuccess: handleSuccess, handleNext: handleNext })),
                activeStep === 2 && (React.createElement(UserForm, { _userData: [userData, setUserData], history: history, setPageShow: setPageShow }))),
            pageShow === PageTypeEnum.detail && (React.createElement(React.Fragment, null,
                React.createElement(StyleAlert, { variant: "filled", severity: "success" }, "\u606D\u559C\u5DF2\u5B8C\u6210\u8A3B\u518A\u8CC7\u6599\uFF01"),
                React.createElement(StyleDiv, null,
                    React.createElement(MasterGrids2, { mGrids: QueryConds })),
                React.createElement(ButtonBar, null,
                    React.createElement("div", null,
                        React.createElement("span", { style: { color: 'red' } }, "\u5BE6\u540D\u8A8D\u8B49\u76EE\u524D\u7B49\u5F85\u95DC\u52D9\u7F72\u3010\u5BE9\u6838\u4E2D\u3011\u7D04\u572812\u5C0F\u6642\u5167\uFF0C\u5982\u4EBA\u5DE5\u5BE9\u67E5\u7D041~3\u65E5\u3002 \u8ACB\u5F85\u5BE9\u67E5\u901A\u904E\u5F8C\u518D\u64CD\u4F5C\u3010\u6D77\u95DC\u5BE6\u540D\u59D4\u4EFB\u3011\u529F\u80FD\u3002")),
                    React.createElement(ButtonContain, { onClick: function () { return props.history.goBack(); } }, "\u56DE\u9996\u9801")))))));
};
export default Register;
var templateObject_1, templateObject_2;
